import { ConversationTagSource } from "@redotech/redo-model/conversation-tags/conversation-tag-record";
import { PillTheme } from "@redotech/redo-model/pill-theme";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getConversationTagsById = {
  name: "getConversationTagsById" as const,
  input: z.object({ tagIds: z.array(zExt.objectId()) }),
  output: z.array(
    z.object({
      _id: zExt.objectId(),
      teamId: zExt.objectId(),
      name: z.string(),
      pillTheme: z.nativeEnum(PillTheme),
      source: z.nativeEnum(ConversationTagSource),
      tagGroupId: zExt.objectId().optional(),
    }),
  ),
};
